import { configureStore } from '@reduxjs/toolkit';
// We will import reducers here later
import authReducer from '../features/auth/authSlice';
import requisitionReducer from '../features/requisitions/requisitionSlice';
import poReducer from '../features/purchase-orders/poSlice';

export const store = configureStore({
  reducer: {
    auth: authReducer,
    requisitions: requisitionReducer,
    purchaseOrders: poReducer,
  },
});

// Infer the `RootState` and `AppDispatch` types from the store itself
export type RootState = ReturnType<typeof store.getState>;
// Inferred type: {auth: AuthState, requisitions: RequisitionsState, ...}
export type AppDispatch = typeof store.dispatch;
